import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const Services = () => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <section className="section" id="features" aria-labelledby="features-heading">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <div className="text-center mb-5 pt-3">
                                <h2 id="features-heading" className="mb-3 ff-secondary fw-semibold lh-base">
                                    {t('landing.features.title')}
                                </h2>
                                <p className="text-muted">
                                    {t('landing.features.subtitle')}
                                </p>
                            </div>
                        </Col>
                    </Row>

                    <Row className="g-3">
                      <Col lg={4}>
                        <div className="d-flex p-3">
                          <div className="flex-shrink-0 me-3">
                            <div className="avatar-sm icon-effect">
                              <div className="avatar-title bg-transparent text-success rounded-circle">
                                <i className="ri-stack-line fs-36"></i>
                              </div>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <h3 className="fs-18">{t('landing.features.eventModes.title')}</h3>
                            <p className="text-muted my-3 ff-secondary">{t('landing.features.eventModes.description')}</p>
                          </div>
                        </div>
                      </Col>

                      <Col lg={4}>
                        <div className="d-flex p-3">
                          <div className="flex-shrink-0 me-3">
                            <div className="avatar-sm icon-effect">
                              <div className="avatar-title bg-transparent text-success rounded-circle">
                                <i className="ri-coins-line fs-36"></i>
                              </div>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <h3 className="fs-18">{t('landing.features.tips.title')}</h3>
                            <p className="text-muted my-3 ff-secondary">{t('landing.features.tips.description')}</p>
                          </div>
                        </div>
                      </Col>

                      <Col lg={4}>
                        <div className="d-flex p-3">
                          <div className="flex-shrink-0 me-3">
                            <div className="avatar-sm icon-effect">
                              <div className="avatar-title bg-transparent text-success rounded-circle">
                                <i className="ri-user-voice-line fs-36"></i>
                              </div>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <h3 className="fs-18">{t('landing.features.inspiration.title')}</h3>
                            <p className="text-muted my-3 ff-secondary">{t('landing.features.inspiration.description')}</p>
                          </div>
                        </div>
                      </Col>

                      <Col lg={4}>
                        <div className="d-flex p-3">
                          <div className="flex-shrink-0 me-3">
                            <div className="avatar-sm icon-effect">
                              <div className="avatar-title bg-transparent text-success rounded-circle">
                                <i className=" ri-qr-code-line fs-36"></i>
                              </div>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <h3 className="fs-18">{t('landing.features.qrCodes.title')}</h3>
                            <p className="text-muted my-3 ff-secondary">{t('landing.features.qrCodes.description')}</p>
                          </div>
                        </div>
                      </Col>

                      <Col lg={4}>
                        <div className="d-flex p-3">
                          <div className="flex-shrink-0 me-3">
                            <div className="avatar-sm icon-effect">
                              <div className="avatar-title bg-transparent text-success rounded-circle">
                                <i className="ri-notification-2-line  fs-36"></i>
                              </div>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <h3 className="fs-18">{t('landing.features.notifications.title')}</h3>
                            <p className="text-muted my-3 ff-secondary">{t('landing.features.notifications.description')}</p>
                          </div>
                        </div>
                      </Col>

                      <Col lg={4}>
                        <div className="d-flex p-3">
                          <div className="flex-shrink-0 me-3">
                            <div className="avatar-sm icon-effect">
                              <div className="avatar-title bg-transparent text-success rounded-circle">
                                <i className="ri-login-box-line fs-36"></i>
                              </div>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <h3 className="fs-18">{t('landing.features.easyAccess.title')}</h3>
                            <p className="text-muted my-3 ff-secondary">{t('landing.features.easyAccess.description')}</p>
                          </div>
                        </div>
                      </Col>

                      <Col lg={4}>
                        <div className="d-flex p-3">
                          <div className="flex-shrink-0 me-3">
                            <div className="avatar-sm icon-effect">
                              <div className="avatar-title bg-transparent text-success rounded-circle">
                                <i className="ri-checkbox-multiple-blank-line fs-36"></i>
                              </div>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <h3 className="fs-18">{t('landing.features.anyDevice.title')}</h3>
                            <p className="text-muted my-3 ff-secondary">{t('landing.features.anyDevice.description')}</p>
                          </div>
                        </div>
                      </Col>

                      <Col lg={4}>
                        <div className="d-flex p-3">
                          <div className="flex-shrink-0 me-3">
                            <div className="avatar-sm icon-effect">
                              <div className="avatar-title bg-transparent text-success rounded-circle">
                                <i className="ri-soundcloud-line  fs-36"></i>
                              </div>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <h3 className="fs-18">{t('landing.features.songDatabase.title')}</h3>
                            <p className="text-muted my-3 ff-secondary">{t('landing.features.songDatabase.description')}</p>
                          </div>
                        </div>
                      </Col>

                      <Col lg={4}>
                        <div className="d-flex p-3">
                          <div className="flex-shrink-0 me-3">
                            <div className="avatar-sm icon-effect">
                              <div className="avatar-title bg-transparent text-success rounded-circle">
                                <i className="ri-instagram-line fs-36"></i>
                              </div>
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <h3 className="fs-18">{t('landing.features.branding.title')}</h3>
                            <p className="text-muted my-3 ff-secondary">{t('landing.features.branding.description')}</p>
                          </div>
                        </div>
                      </Col>

                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Services;
